import { resolveClient } from './supabase';
import type { PortfolioCompany } from '@lingaai/types';
import type { SupabaseClient } from '@supabase/supabase-js';

export async function getPortfolioCompanies(fundId?: string, client?: SupabaseClient): Promise<PortfolioCompany[]> {
  const supabase = resolveClient(client);

  let query = supabase.from('portfolio_companies').select('*').order('name', { ascending: true });

  if (fundId) {
    query = query.eq('fund_id', fundId);
  }

  const { data, error } = await query;

  if (error) throw error;
  return data as PortfolioCompany[];
}

export async function getPortfolioCompany(companyId: string, client?: SupabaseClient): Promise<PortfolioCompany> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('portfolio_companies').select('*').eq('id', companyId).single();

  if (error) throw error;
  return data as PortfolioCompany;
}

export async function createPortfolioCompany(
  data: {
    tenant_id: string;
    fund_id: string;
    name: string;
    website?: string | null;
    sector?: string | null;
    external_id?: string | null;
    investment_date?: string | null;
  },
  client?: SupabaseClient
): Promise<PortfolioCompany> {
  const supabase = resolveClient(client);

  const { data: company, error } = await supabase.from('portfolio_companies').insert(data).select().single();

  if (error) throw error;
  return company as PortfolioCompany;
}

export async function updatePortfolioCompany(companyId: string, updates: Partial<PortfolioCompany>, client?: SupabaseClient): Promise<PortfolioCompany> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('portfolio_companies').update(updates).eq('id', companyId).select().single();

  if (error) throw error;
  return data as PortfolioCompany;
}
